export function positionBetween(start: number, end: number, percentage: number){
    // if(percentage < .807)
    //     percentage = ((percentage + 0.315)**.2 - .5) *2.2;
    // else percentage = .1/percentage+.9
    percentage = -1.6*percentage**2+2.6*percentage;
    let delta = (end-start) * percentage;

    return start + delta;
}
export function roundToNearest(number: number, width: number) {
    return Math.round(number / width) * width;
}
